export const mockSessionEndpointResponse = {
  code: '1001',
  sessionId: 'cde99922-0c6c-4308-8b89-8d5e7f9d7dc',
};
